import type { ReactNode } from 'react';
import { useSnapshot } from 'valtio';

import sessionStore from '~/components2/TokenValidator/store';

/**
 * Renders `children` only while the session is live, so mapbox sources unmount on expiry and stop
 * requesting tiles with a dead token.
 *
 * Subscribes synchronously because valtio otherwise defers the notification to a microtask, which
 * would let another round of tile requests go out.
 */
const LiveSessionOnly = ({ children }: { children: ReactNode }) => {
  const { isSessionExpired } = useSnapshot(sessionStore, { sync: true });
  return isSessionExpired ? null : <>{children}</>;
};

export default LiveSessionOnly;
